import { useEffect } from "react";

function Contact() {
  useEffect(() => {
    const footer = document.querySelector("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []);

  return null;
}

export default Contact;
